import axios, { AxiosError, AxiosResponse } from 'axios';
import { requestHeader } from './RequestHeaderValue';
import * as Sentry from '@sentry/react';

export async function axiosRequestHandler(
  queryKey: string,
  useEPErrors: boolean = false,
  noRedirect: boolean = false
) {
  let debugMode: boolean = false;
  const response = await axios
    .get(queryKey)
    .catch(function (error: AxiosError) {
      if (error.response) {
        const debugHeaderValue = requestHeader(error.response, 'debug');
        if (debugHeaderValue && debugHeaderValue === 'true') {
          debugMode = true;
        }
      }
      Sentry.captureException(error);
      if (useEPErrors && error.response?.data.errorMessage && error.response?.data.statusCode !== 500) {
        return {
          data: {
            errorMessage: error.response.data.errorMessage,
          },
        };
      }
      if (noRedirect) {
        throw Error('Couldnt load ' + queryKey);
      } else {
        errorManager(error.response, debugMode);
        throw Error;
      }
    });
  return response;
}

function errorManager(
  response: AxiosResponse<any> | undefined,
  debugMode: boolean
): void {
  const isHonda = process.env.REACT_APP_THEME === 'honda';
  switch (response?.status || 0) {
    default:
      if (debugMode) {
        var errorData = {
          status: response?.status,
          endpoint: response?.config.url || 'not provided',
          message: response?.data?.errorMessage || 'not provided',
          exceptions: response?.data?.innerExceptions || 'not provided',
        };
        localStorage.setItem('ahm-diagnostics-data', JSON.stringify(errorData));
      } else {
        window.location.href = isHonda ? '/errors/500' : '/500';
      }
  }
}
